<template>
  <div>
    <RentalParentBar type="invoices" />
    <layout :isSuccess="true" :isFull="true">
      <template v-slot:containerZone>
        <div class="container-invoice">
          <div class="header-invoice">
            <div class="header-invoice-box left">
              <div class="header-text">{{ $t('invoice.title') }}</div>
              <div class="header-date">
                <SelectMonthYear :isDisabled="isLoading" :startMonth="startMonth" :startYear="startYear"
                  @onSelect="onSelectMonthYear" />
              </div>
            </div>
            <div class="header-invoice-box right">
              <v-menu v-if="!isShowSelectSendInvoice">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="info" :disabled="isLoading || isSending || isShowSelectPrintInvoice
                    " v-bind="attrs" v-on="on">
                    <v-icon left>mdi-send</v-icon>{{ $t('bill.send_bill') }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="confirmSendInvoce('all')">
                    <v-list-item-title>{{ $t('bill.send_all_bill') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="isShowSelectSendInvoice = true">
                    <v-list-item-title>{{ $t('bill.select_bill') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <template v-else>
                <v-btn color="info" @click="confirmSendInvoce('select')" :disabled="isLoading ||
                  isSending ||
                  selectedInvoices.length <= 0
                  ">
                  <v-icon left>mdi-send</v-icon>
                  {{ $t('bill.send_bill_count', { select: selectedInvoices.length }) }}
                </v-btn>
              </template>
              <v-btn color="info" @click="exportInvoice()" :disabled="isLoading || isSending">
                <v-icon class="me-2">mdi-file-excel-outline</v-icon>Export Excel
              </v-btn>
              <v-menu v-if="!isShowSelectPrintInvoice">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="info" :disabled="isLoading || isShowSelectSendInvoice" v-bind="attrs" v-on="on">
                    <v-icon left>mdi-printer</v-icon>{{ $t('invoice.print_invoice') }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="printInvoice('all')">
                    <v-list-item-title>{{ $t('bill.print_all') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="choosePrintInvoice('select')">
                    <v-list-item-title>{{ $t('bill.select_bill') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="choosePrintInvoice('unpaid')">
                    <v-list-item-title>{{ $t('bill.select_bill_pending') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="choosePrintInvoice('paid')">
                    <v-list-item-title>{{ $t('bill.select_bill_paid') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="choosePrintInvoice('unconnect')">
                    <v-list-item-title>{{ $t('bill.select_bill_only_customer_not_connect_system') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <template v-else>
                <v-btn color="info" @click="printInvoice('select')"
                  :disabled="isLoading || isSending || selectedInvoices.length <= 0">
                  <v-icon left>mdi-printer</v-icon>
                  {{ $t('bill.print_bill', { count: selectedInvoices.length }) }}
                </v-btn>
              </template>
              <v-btn v-show="isShowSelectSendInvoice || isShowSelectPrintInvoice" color="error"
                @click="selectedInvoices = []; isShowSelectSendInvoice = false; isShowSelectPrintInvoice = false;">{{
                  $t('cancel')
                }}</v-btn>
              <v-text-field solo dense background-color="grey lighten-4" flat type="text" :placeholder="$t('search')"
                :label="$t('search')" prepend-inner-icon="mdi-magnify" v-model="searchText" clearable color
                hide-details></v-text-field>
            </div>
          </div>
          <div class="data-invoice">
            <v-data-table
              ref="dataTableInvoice"
              v-model="selectedInvoices"
              :no-data-text="$t('invoice.no_invoice')"
              :no-results-text="$t('no_matching_records_found')"
              :loading-text="$t('loading')"
              :loading="isLoading"
              :headers="dataTable.headers"
              :items="dataTable.data"
              :items-per-page="20"
              item-key="objectId"
              class="elevation-1 data-table-invoice"
              :search="searchText"
              :show-select="isShowSelectSendInvoice || isShowSelectPrintInvoice"
              :single-select="false"
              @toggle-select-all="selectAll"
              :item-class="itemRowClass">
              <template v-slot:item.data-table-select="{ isSelected, select, item }">
                <template v-if="isShowSelectSendInvoice && !item.isErrorBilling && !item.isSent">
                  <v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"
                    :disabled="item.penaltyDays > 0 && item.penaltyItem"></v-simple-checkbox>
                </template>
                <template v-if="isShowSelectPrintInvoice && item.isSent && !item.isErrorBilling">
                  <v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"
                    :disabled="item.penaltyDays > 0 && item.penaltyItem"></v-simple-checkbox>
                </template>
              </template>

              <template v-slot:header.contractAreas="{ header }">
                <div class="text-nowrap-table text-center" style="min-width:80px;">{{ header.text }}</div>
              </template>
              <template v-slot:header.customerData.name="{ header }">
                <div class="text-nowrap-table text-center" style="min-width:100px">{{ header.text }}</div>
              </template>

              <template v-slot:item.date="{ item }">
                <div class="d-flex align-center justify-center">
                  <v-tooltip top color="primary" v-if="item.isSent && item.isViewed">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" style="margin-left: -13px; margin-top: -2px;">
                        <v-btn color="primary" fab x-small dark elevation="0"
                          style="pointer-events: none; width: 15px; height: 15px;" class="me-1">
                          <v-icon style="font-size: 14px;">mdi-check-all</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{ $t('customer.customer_already_read') }}</span>
                  </v-tooltip>
                  <div v-else style="width: 13px;"></div>
                  <template v-if="item.date">{{ $moment(item.date).format("DD/MM/YYYY") }}</template>
                </div>
              </template>
              <template v-slot:item.contractAreas="{ item }">
                <div class="text-truncate area-name">{{ item.contractAreas }}</div>
              </template>
              <template v-slot:[`item.customerData.name`]="{ item }">
                <div class="text-truncate customer-name">
                  <v-tooltip top v-if="item.contractIsConnect">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" size="18" right color="primary">mdi-account-check</v-icon>
                    </template>
                    <span>{{ $t('area.connected_to_application') }}</span>
                  </v-tooltip>
                  {{ item.customerData ? item.customerData.name : '' }}
                </div>
              </template>
              <template v-slot:item.dueDate="{ item }">
                <template v-if="item.dueDate">{{ $moment(item.dueDate).format("DD/MM/YYYY") }}</template>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn @click="confirmSendInvoce('one', item)" outlined small class="mx-1 my-1"
                  color="rgb(100, 100, 100)" v-if="!item.isSent && !item.isCancelled"
                  :disabled="isLoading || isSending || item.isErrorBilling || (item.penaltyDays > 0 && item.penaltyItem ? true : false)">
                  <v-icon>mdi-send</v-icon>
                </v-btn>
                <v-btn @click="onTableRowClick(item)" outlined small class="mx-1 my-1" color="rgb(100, 100, 100)"
                  :disabled="isLoading">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip :class="item.statusClass.class" :color="item.statusClass.color">{{ item.statusClass.text
                }}</v-chip>
                <v-chip class="ms-1 px-0 py-0" color="rgb(255, 137, 59, 0.3)" v-if="item.invoicePayment">
                  <img width="32" :src="require(`../../assets/images/money-sign-orange.svg`)" />
                </v-chip>
              </template>
              <template v-slot:item.totalValue="{ item }">
                <div class="text-nowrap text-end">
                  {{ item.totalValue | currencyPrefixSign(item.currencyCode) }}
                </div>
              </template>
              <template v-slot:item.totalUnpaidValue="{ item }">
                <div class="text-nowrap text-end">
                  {{ item.totalUnpaidValue | currencyPrefixSign(item.currencyCode) }} 
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
      </template>
    </layout>

    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-dialog v-model="isConfirmSendAllDialog" max-width="500">
      <v-card>
        <!-- <v-progress-linear
          v-model="sendingPercent"
          color="amber"
          height="25"
        ></v-progress-linear>-->
        <v-card-title class="text-h5">
          <h4>{{ $t('payment.confirminvoice') }} ?</h4>
        </v-card-title>

        <v-card-text>{{ $t('bill.all_bill', { count: sendInvoices.length }) }}</v-card-text>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span>{{ $t('invoice.invoice_date') }}</span>
              <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="$helper.datelabel(formData.date)" :placeholder="$t('date')" outlined dense
                    hide-details readonly v-bind="attrs" v-on="on" prepend-inner-icon="mdi-calendar"></v-text-field>
                </template>
                <v-date-picker v-model="formData.date" no-title locale="th" @input="menuDate = false"
                  :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <span>{{ $t('market.due_date') }}</span>
              <v-menu v-model="menuDueDate" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="$helper.datelabel(formData.dueDate)" :placeholder="$t('market.due_date')"
                    outlined dense hide-details readonly v-bind="attrs" v-on="on"
                    prepend-inner-icon="mdi-calendar"></v-text-field>
                </template>
                <v-date-picker v-model="formData.dueDate" no-title locale="th" @input="menuDueDate = false"
                  :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="default" @click="isConfirmSendAllDialog = false">{{ $t('close') }}</v-btn>
          <v-btn @click="sendAllInvoce()" class="primary">{{ $t('confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <LoadingPercentDialog v-model="isLoadingDialog" :final="loadingFinal" :initial="loadingInitial" />
    <InvoiceDialog v-model="isAddInvoiceDialog" :invoiceId="invoiceId" :projectId="projectId"
      @onSaveSuccess="onSaveSuccess" />
    <PrintDialog elementId="print-invoices" type="invoice" v-model="isPrintDialog"
      :invoiceIds="selectedInvoices.map((d) => d.objectId)" />
    <QuotationDialog v-model="isQuotationDialog" :projectId="projectId" type="area-interest"
      @onSaveSuccess="onSaveSuccess" />
  </div>
</template>

<script>
import InvoiceDialog from "@/components/InvoiceDialog.component";
import SelectMonthYear from "@/components/SelectMonthYear.component";
import ParentBar from "@/components/ParentBar.vue";
import RentalParentBar from "../../components/RentalParentBar.component";
import LoadingPercentDialog from "../../components/LoadingPercentDialog.component";
import Layout from "@/components/Layout.vue";
import ConfirmDialog from "../../components/ConfirmDialog.component";
import PrintDialog from "../../components/PrintDialog.component.vue";
import { mapGetters } from "vuex";
import QuotationDialog from "@/components/QuotationDialog.component";
import { ExportAccounting } from "../../exports";
export default {
  computed: {
    invoices() {
      return this.$store.getters["invoice/getMonthlyInvoices"](this.selectedMonthYear?.month, this.selectedMonthYear?.year);
    },
    dataTable() {
      return {
        headers : [
          {
            text: this.$t('date'),
            value: "date",
            width: "8%",
            key: "date",
            align: "center"
          },
          {
            text: this.$t('market.document_id'),
            value: "documentId",
            align: "center",
            width: "11%"
          },
          {
            text: this.$t('contract.contract_number_only'),
            value: "contract.contractId",
            align: "center",
            width: "10%"
          },
          {
            text: this.$t('contract.contract_in_area'),
            value: "contractAreas",
            width: "1%",
            align: "center hd-resize text-truncate area-name",
            class: "custom-sort",
          },
          {
            text: this.$t('bill.customer_market_id'),
            value: "contract.customerMarketId",
            align: "center",
            width: "10%"
          },
          {
            text: this.$t('market.marchant_name'),
            value: "customerData.name",
            width: "1%",
            align: "left hd-resize text-truncate",
            sortable: false,
          },
          {
            text: this.$t('bill.receipt_id'),
            value: "receiptsId",
            align: "center",
            width: "11%"
          },
          {
            text: this.$t('invoice.installment_due_date'),
            value: "dueDate",
            align: "center",
            width: "7%"
          },
          {
            text: this.$t('market.total_value'),
            value: "totalValue",
            width: "7%",
            align: "right"
          },
          {
            text: this.$t('invoice.remaining_amount'),
            value: "totalUnpaidValue",
            width: "7%",
            align: "right"
          },
          {
            text: this.$t('status'),
            value: "status",
            sortable: false,
            width: "5%",
            align: "center"
          },
          {
            text: "",
            value: "actions",
            sortable: false,
            align: "center"
          }
        ],
        data: this.invoices.sort((a, b) => (a.order || 0) - (b.order || 0))
      };
    },
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      project: null,
      market: null,
      isAddInvoiceDialog: false,
      selectedMonthYear: null,
      isError: false,
      isLoading: false,
      invoiceId: null,
      isSending: false,
      isConfirmSendAllDialog: false,
      sendInvoices: [],
      sendingPercent: 50,
      isLoadingDialog: false,
      loadingFinal: 0,
      loadingInitial: 0,
      searchText: "",
      isSendConfirmDialog: false,
      invoiceId: "",
      selectedInvoices: [],
      isShowSelectSendInvoice: false,
      isShowSelectPrintInvoice: false,
      startMonth:
        this.$moment()
          .add(1, "months")
          .month() + 1,
      startYear: this.$moment()
        .add(1, "months")
        .year(),
      formData: {
        date: this.$moment().toISOString(),
        dueDate: this.$moment()
          .add(7, "days")
          .toISOString()
      },
      menuDate: false,
      menuDueDate: false,
      isPrintDialog: false,
      isQuotationDialog: false,

    };
  },
  components: {
    InvoiceDialog,
    SelectMonthYear,
    ParentBar,
    RentalParentBar,
    LoadingPercentDialog,
    Layout,
    ConfirmDialog,
    PrintDialog,
    QuotationDialog
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }
    if (this.market && this.market.billingType == 1) {
      this.startMonth = this.$moment().month() + 1;
      this.startYear = this.$moment().year();
    }
  },
  methods: {
    async initData() {
      try {
        await this.$store.dispatch("invoice/getMonthlyInvoices", {
          projectId: this.projectId,
          marketId: this.marketId,
          meterMonth: this.selectedMonthYear.month,
          meterYear: this.selectedMonthYear.year
        });
        this.selectedInvoices = [];
        this.isShowSelectSendInvoice = false;
      } catch (error) {
        throw error;
      }
    },
    async onSelectMonthYear(data) {
      this.isLoading = true;
      try {
        this.selectedMonthYear = data;
        await this.initData();
        this.isLoading = false;
      } catch (error) {
        console.log("~ error", error);
        this.isLoading = false;
        this.isError = true;
      }
    },
    onTableRowClick(invoice) {
      this.invoiceId = invoice.objectId;
      this.isAddInvoiceDialog = true;
    },
    async onSaveSuccess() {
      this.isLoading = true;
      try {
        await this.initData();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    confirmSendInvoce(type, invoice) {
      if (type == "all") {
        this.sendInvoices = this.invoices.filter(d => !d.isErrorBilling && !d.isSent && !d.isCancelled);
      } else if (type == "select") {
        this.sendInvoices = this.selectedInvoices.filter(d => !d.isErrorBilling && !d.isSent && !d.isCancelled);
      } else if (type == "one") {
        this.sendInvoices = invoice && !invoice.isErrorBilling && (!invoice.isSent && !invoice.isCancelled) ? [invoice] : [];
      }
      if (this.sendInvoices.length == 1) {
        if (this.sendInvoices[0].date)
          this.formData.date = this.sendInvoices[0].date;
        if (this.sendInvoices[0].dueDate)
          this.formData.dueDate = this.sendInvoices[0].dueDate;
      } else {
        this.formData.date = this.$moment().toISOString();
        let creditTerm = 7;
        if (
          this.sendInvoices &&
          this.sendInvoices[0] &&
          this.sendInvoices[0].market &&
          this.sendInvoices[0].market.creditTerm
        )
          creditTerm = this.sendInvoices[0].market.creditTerm;
        if (
          type == "one" &&
          this.sendInvoices &&
          this.sendInvoices[0] &&
          this.sendInvoices[0].contract &&
          this.sendInvoices[0].contract.creditTerm
        )
          creditTerm = this.sendInvoices[0].contract.creditTerm;
        this.formData.dueDate = this.$moment()
          .add(creditTerm, "days")
          .toISOString();
      }
      this.isConfirmSendAllDialog = true;
    },
    prepareInvoiceItems(itemsIn) {
      return itemsIn.map(d => {
        let obj = {};
        if (d.area) {
          if (!d.area.isRemove) {
            obj.area = d.area;
          }
        }
        if (d.meter) obj.meter = d.meter;
        if (d.billingSetting) obj.billingSetting = d.billingSetting;
        if (d.accountingProduct) obj.accountingProduct = d.accountingProduct;
        obj.name = d.name;
        obj.detail = d.detail;
        obj.unit = d.unit;
        obj.quantity = d.quantity;
        obj.originalPricePerUnit = d.originalPricePerUnit;
        obj.sellVatType = d.sellVatType;
        obj.whtPercent = d.whtPercent;
        obj.totalValue = d.totalValue;
        obj.totalVatValue = d.totalVatValue;
        obj.totalNonVatValue = d.totalNonVatValue;
        obj.totalWhtValue = d.totalWhtValue;
        obj.type = d.type;
        obj.discountType = d.discountType;
        obj.discountPerUnit = d.discountPerUnit;
        obj.originalDiscountPerUnit = d.originalDiscountPerUnit;
        obj.totalDiscountValue = d.totalDiscountValue;
        obj.totalDiscountVatValue = d.totalDiscountVatValue;
        obj.totalDiscountNonVatValue = d.totalDiscountNonVatValue;
        return obj;
      });
    },
    async sendAllInvoce() {
      this.isSending = true;
      this.isConfirmSendAllDialog = false;
      this.isLoadingDialog = true;
      this.loadingFinal = 0;
      try {
        let invoiceIdList = this.sendInvoices.map(d => {
          return d.objectId;
        });
        this.loadingInitial = invoiceIdList.length;
        for (let sendInvoice of this.sendInvoices) {
          if (
            sendInvoice &&
            (sendInvoice.penaltyItem ||
              (sendInvoice.penaltyItems && sendInvoice.penaltyItems.length))
          ) {
            let items = this.prepareInvoiceItems(sendInvoice.items);
            await this.$store.dispatch("invoice/updateInvoice", {
              id: sendInvoice.objectId,
              items
            });
          }
          await this.$store.dispatch("invoice/sendInvoice", {
            id: sendInvoice.objectId,
            date: this.$moment(this.formData.date)
              .startOf("day")
              .toDate(),
            dueDate: this.$moment(this.formData.dueDate)
              .endOf("day")
              .toDate()
          });
          this.loadingFinal++;
        }
        this.isShowSelectSendInvoice = false;
        this.sendInvoices = [];
        this.isSending = false;
        this.isLoadingDialog = false;
      } catch (error) {
        console.log(error);
        this.isShowSelectSendInvoice = false;
        this.sendInvoices = [];
        this.isSending = false;
        this.isLoadingDialog = false;
        this.isError = true;
      }
    },
    confirmDialog(invoiceId) {
      this.invoiceId = invoiceId;
      this.isSendConfirmDialog = true;
    },
    choosePrintInvoice(type) {
      this.selectedInvoices = [];
      if (type == "all") {
        this.selectedInvoices = this.invoices.filter(d => d.isSent);
      } else if (type == "unpaid") {
        this.selectedInvoices = this.invoices.filter(
          d => d.isSent && !d.isPaid
        );
      } else if (type == "paid") {
        this.selectedInvoices = this.invoices.filter(d => d.isSent && d.isPaid);
      } else if (type == 'unconnect') {
        this.selectedInvoices = this.invoices.filter(d => d.isSent && !d.contractIsConnect);
      }
      this.isShowSelectPrintInvoice = true;
    },
    printInvoice(type) {
      if (type == "all") {
        this.selectedInvoices = this.invoices.filter(
          d => d.isSent && !d.isErrorBilling
        );
      }
      this.isPrintDialog = true;
    },
    selectAll() {
      const filter = this.invoices.filter(i => !i.isErrorBilling && !i.isSent);
      if (this.selectedInvoices.length == filter.length) {
        this.selectedInvoices = [];
      } else {
        this.selectedInvoices = filter;
      }
    },
    exportInvoice() {
      try {
        let invoices = this.$refs.dataTableInvoice.$children[0].filteredItems || []
        ExportAccounting.exportInvoiceList(
          invoices,
          null,
          null,
          this.selectedMonthYear.month + "-" + this.selectedMonthYear.year,
          this.$globalVatPercent
        );
      } catch (err) {
        this.isError = true;
      }
    },
    itemRowClass(invoice) {
      if (invoice.isSent && invoice.isViewed) {
        return "bg-green-50";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.data-table-invoice::v-deep td.hd-resize {
  max-width: 100px;
}

.data-table-invoice::v-deep td.hd-resize.area-name {
  max-width: 80px;
}

.data-table-invoice::v-deep th.custom-sort {
  position: relative;

  .v-icon {
    position: absolute;
    right: 30px;
    top: 15px;
  }
}

.data-table-invoice::v-deep {
  .v-data-table__wrapper {
    overflow-x: auto;
  }

  td:last-child,
  th:last-child {
    position: sticky !important;
    right: 0;
    z-index: 1;
    background-color: white;
  }

  th:last-child {
    z-index: 2;
  }

  td:last-child::after,
  th:last-child::after {
    content: '';
    position: absolute;
    left: -4px;
    top: 0;
    height: 100%;
    width: 4px;
  }
}

.container-invoice {
  .header-invoice {
    display: flex;
    background: #FFFFFF;
    padding: 15px;
    gap: 15px;

    .header-invoice-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 10px 5px;
      align-items: center;

      .v-input {
        max-width: 250px;
      }
    }

    .header-invoice-box.left {
      flex: 1;
      gap: 30px;
      max-width: calc(50% - 200px);

      .header-text {
        font-size: 30px;
        font-weight: bolder;
      }

      .header-date {
        max-width: 200px;
      }
    }

    .header-invoice-box.right {
      flex: 1;
      gap: 10px;
      justify-content: flex-end;
    }
  }

  .data-invoice {
    margin-top: 10px;
    margin-bottom: 25px;
  }

  .text-nowrap {
    white-space: nowrap;
  }
}
</style>